import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { SaveOutlined } from '@ant-design/icons';
import { Form, message, Modal } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getErrorMessages, getModalMessages, getRequestMessages } from '../../constants/messages';
import { GetAllClients } from '../Clients/actions';
import { GetAllContacts } from '../Contacts/actions';
import { GetDevicesByClientId } from '../Devices/actions';
import { REQUESTTYPES } from '../Jobs/constants';
import { AddRequest, GetRequests, notifySlack } from './actions';
import AddRequestForm from './AddRequestForm';

let modalMessages = getModalMessages(),
	requestMessages = getRequestMessages(),
	errorMessages = getErrorMessages();

const messages = {
	...modalMessages,
	...requestMessages,
	...errorMessages,
};

const AddRequestModal = ({ handleCancel, visible }) => {
	const intl = useIntl();
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [isSaving, setIsSaving] = useState(false);
	const [devices, setDevice] = useState([]);
	const user = useSelector((state) => state.auth.user);
	const clients = useSelector((state) => state.client.clients);

	const selectedClientId = Form.useWatch('clientId', form);
	const requestType = Form.useWatch('type', form);

	useEffect(() => {
		const fetchDevices = async () => {
			if (selectedClientId && requestType !== REQUESTTYPES.INSTALLATION.id) {
				try {
					const client = clients.find((client) => client.id === selectedClientId);
					const devices = await GetDevicesByClientId(client.clientId);
					setDevice(devices);
				} catch (error) {
					messages.error(intl.formatMessage({ ...messages.commonError }));
					setDevice([]);
				}
			} else {
				setDevice([]);
			}
		};

		fetchDevices();
	}, [selectedClientId]);

	useEffect(() => {
		if (!visible) {
			form.resetFields();
		}
	}, [visible]);

	useEffect(() => {
		(async () => {
			try {
				await dispatch(GetAllClients());
				await dispatch(GetAllContacts());
			} catch (error) {
				message.error(intl.formatMessage({ ...messages.GetClientsError }));
			}
		})();
	}, []);

	const onOk = async () => {
		try {
			setIsSaving(true);
			const values = await form.validateFields();
			values.devices = JSON.stringify(values.devices);
			values.vehicles = JSON.stringify(values.vehicles);
			values.createdAt = moment();
			values.createdBy = user.id;
			const request = await dispatch(AddRequest(values));
			await notifySlack(request.id);
			await dispatch(GetRequests());
			message.success(intl.formatMessage({ ...messages.addRequestSuccess }));
			handleCancel();
		} catch (error) {
			message.error(intl.formatMessage({ ...messages.addRequestError }));
		} finally {
			setIsSaving(false);
		}
	};

	return (
		<Modal
			open={visible}
			title={intl.formatMessage({ ...messages.addRequest })}
			destroyOnClose={true}
			confirmLoading={isSaving}
			onOk={onOk}
			okText={
				<span>
					<SaveOutlined />
					<FormattedMessage {...messages.save} />
				</span>
			}
			onCancel={handleCancel}
			cancelText={intl.formatMessage({ ...messages.cancel })}
		>
			<AddRequestForm form={form} devices={devices} />
		</Modal>
	);
};

AddRequestModal.propTypes = {
	handleCancel: PropTypes.func.isRequired,
	visible: PropTypes.bool,
};

export default AddRequestModal;
